<template>

  <div>
    <div class="row  no-gutters pt-xl-4 mb-xl-6">
      <div class="col-xl-3 col-6 tab-test-bird order-xl-1 order-2">

      </div>
      <div class="col-xl-6 col-12 tab-test-title order-xl-2 order-1 text-center pt-xl-3 mt-xl-0 mt-4"
           v-if="lesson">
        {{ lesson.lesson }}
      </div>
      <div class="col-xl-3 col-6 tab-video-points test-line order-xl-3 order-3" v-if="points && testmode==0">
        <div class="zerno-points">
          {{ points }}
        </div>
      </div>
      <div class="col-xl-12 col-12 tab-video-notice order-xl-4 order-4 text-center mt-xl-n7 mt-n5 mb-xl-0 mb-3">
        <div class="tab-video-notice-1">{{ $t('test') }} {{ $t('№') }}{{ test.pos }}
          <span class="ml-2" v-if="testsCount > 0">({{ test.pos }} {{ $t('of') }} {{ testsCount }})</span>
        </div>
      </div>

      <div class="col-12 order-10 text-center" v-if="showTestIntro && test">

        <h2 class="mt-7" v-if="test.test">{{ test.test }}</h2>
        <h2 class="mt-7" v-else>{{ $t('test') }} {{ $t('№') }}{{ test.pos }}</h2>
        <h1 class="mb-5 mt-2" v-if="test.description">«{{ test.description }}»</h1>
        <button
            class="btn btn-success btn-large btn-lg mb-9 btn-to-next-lesson"
            @click="startTest">
          <i class="ni ni-spaceship mr-2"></i>{{ $t('start_test') }} {{ $t('№') }}{{ test.pos }}
        </button>

      </div>

      <div class="col-12 order-10" v-if="!showTestIntro && test">

        <div class="row ml-xl-0 mr-xl-0 ml-3 mr-3 justify-content-center">

          <div class="col-xl-12 col-12 test-question-content text-center mt-xl-n4"
               v-if="currentTask.testtask">
                        <span v-if="currentTask.pos && !currentTask.testtask.startsWith($t('№')+currentTask.pos)"
                              class="mr-3">{{ $t('№') }}{{ currentTask.pos }}.</span>{{ currentTask.testtask }}
          </div>

          <div class="col-12 tab-video-notice-2 text-center pl-xl-0 pl-6 pr-xl-0 pr-6 mb-xl-4"
               v-if="test.description && test.description !== currentTask.testtask">{{
              test.description
            }}
          </div>

          <div class="col-xl-12 col-12 mb-xl-4 mb-4 mt-2 drop-wrapper">
            <div>
              <container
                  :orientation="'horizontal'"
                  group-name="col"
                  :get-child-payload="index => {return this.testelements[index]}"
                  class="ma-4 row text-center align-content-center"
                  @drop="onDrop"
              >
                <draggable
                    class="col-lg-3 col-6"
                    v-for="child in testelements"
                    :key="child.idtestelement"
                    @touchmove.native="draggableMove"
                >
                  <div class="py-4">
                    <img
                        class="test-image-btn test-image  drop-image-shadow"
                        style="pointer-events: none;"
                        :src="child.image"
                    />
                  </div>
                </draggable>
              </container>
            </div>
          </div>
          <div class="col-12">
            <div class="row justify-content-center text-center no-gutters">

              <div
                  v-for="(item,ind) in testelementsDropZone"
                  :key="'zone' + ind"
                  :class="['col-lg-3', 'col-6']"
              >
                <div :class="['drop-zone', item.color]">
                  <div class="justify-center ma-0 pa-0 pt-2 drop-word">
                    {{ item.word }}
                  </div>
                  <div class="ma-0 pa-0">
                    <container
                        group-name="col"
                        :should-accept-drop="(src, payload) => { return testelementsDropZone[ind].child.length===0 || payload===testelementsDropZone[ind].child[0] }"
                        :get-child-payload="getCardPayload(ind)"
                        no-drag-class="card-ghost"
                        no-drop-class="card-ghost-drop"
                        :drop-placeholder="dropPlaceholderOptions"
                        class="ma-4 text-center"
                        @drop="(e) => onCardDrop(ind, e)"
                    >
                      <draggable
                          v-for="child in testelementsDropZone[ind].child"
                          :key="child.idtestelement"
                          @touchmove.native="draggableMove"
                      >
                        <div
                            class="ma-3 py-4">
                          <img
                              class="test-image"
                              style="pointer-events: none;"
                              max-width="200"
                              :src="child.image"
                          />
                        </div>
                      </draggable>
                    </container>
                  </div>
                </div>
              </div>
            </div>
            <div class="row justify-content-center text-center no-gutters">
              <button
                  v-if="testmode==1 && done"
                  class="btn btn-info mt-2"
                  @click="next"
              >
                {{ $t('accept_answer') }}
              </button>
            </div>
          </div>


        </div>

      </div>


    </div>
    <div class="row mb-4 mt-1 justify-content-center no-gutters" v-if="!showTestIntro && test">
      <button
          class="btn btn-info"
          @click="skip"
      >
        {{ $t('omit_task') }} &rarr;
      </button>
    </div>
  </div>

</template>

<style src="@/assets/poliglotiki/main.css">
</style>
<script>
import api from '@/utils/api'
import {Container, Draggable} from 'vue-smooth-dnd'

export default {
  name: 'Test1',
  components: {
    Container,
    Draggable,
  },
  props: {
    idtest: {default: null},
    lesson: {type: Object, default: null},
    points: {default: null},
    testsCount: {default: null},
    showButtons: {type: Boolean, default: true},
    testmode: {default: 0},
  },
  data: () => ({
    test: {},
    testtasks: [],
    testelements: [],
    taskIdx: 0,
    audio: new Audio(),
    done: false,
    complete: false,
    errorCount: 0,

    testelementsDropZone: [],

    forceRenderKey: 0,

    upperDropPlaceholderOptions: {
      className: 'cards-drop-preview',
      animationDuration: '150',
      showOnTop: true,
    },
    dropPlaceholderOptions: {
      className: 'drop-preview',
      animationDuration: '150',
      showOnTop: true,
    },

    showTestIntro: true,

    //errorChord: 'gong.mp3',
    errorChord: 'https://www.poliglotiki.ru/images/pol-mp3/error_chord.mp3',
    okChord: 'https://www.poliglotiki.ru/images/pol-mp3/ok.mp3',
  }),

  computed: {
    currentTask: function () {
      return (this.taskIdx < this.testtasks.length) ? this.testtasks[this.taskIdx] : {}
    },
  },

  watch: {
    taskIdx: function () {
      this.loadTask()
    },
  },

  async mounted() {
    api({url: '/tests/' + this.idtest}).then(resp => {
      this.test = resp.data
    })
    const response = await api({url: '/testtasks?sort=pos' + (this.idtest ? '&filter[idtest]=' + this.idtest : '')})
    this.testtasks = response.data

    // workaround for "once smooth-dnd is touched, can not scroll any more page" https://github.com/kutlugsahin/smooth-dnd/issues/83#issuecomment-713486752
    const cleanClasses = () => {
      document.body.className = '';
    };
    document.addEventListener('touchend', cleanClasses, false);
  },

  methods: {
    async startTest() {
      if (this.testtasks.length) {
        if (this.test.audio) {
          await this.play(this.test.audio)
        }
        this.showTestIntro = false
        this.loadTask()
      }
    },
    async loadTask() {
      if (this.currentTask.idtesttask) {
        const response = await api({
          method: 'get',
          url: '/testelements?filter[idtesttask]=' + this.currentTask.idtesttask
        })
        this.testelements = response.data

        this.testelementsDropZone = []
        for (let index = 0; index < this.testelements.length; index++) {
          this.testelementsDropZone.push({
            idtestelement: this.testelements[index].idtestelement,
            word: this.testelements[index].word,
            color: 'white',
            child: []
          })
        }

        this.testelements = this.shuffle(this.testelements)
      } else {
        this.$emit('testComplete')
      }
    },

    getBy(propname, value, array) {
      for (let index = 0; index < array.length; index++) {
        if (array[index][propname] === value) return array[index]
      }

      return {}
    },

    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]]
      }
      return a
    },

    play: function (path) {
      return new Promise((resolve) => {
        if (path) {
          this.audio.src = path
          this.audio.play()
          this.audio.onended = function () {
            // console.log('Звук закончился')
            resolve()
          }

          this.audio.onerror = function () {
            console.log('Звук error')
            resolve()
          }
        } else {
          resolve()
        }
      })
    },
    next: async function () {
      if (this.complete) this.$emit('correctAnswer')
      else this.$emit('wrongAnswer', {
        test: this.test.test,
        taskIdx: this.taskIdx,
        error: `Неправильно соединено элементов: ${this.errorCount}.`
      })
      this.taskIdx++
    },

    skip: function () {
      this.$emit('wrongAnswer', {test: this.test.test, taskIdx: this.taskIdx, error: 'Пропущено'})
      this.taskIdx++
    },

    onDrop(dropResult) {
      this.testelements = this.applyDrag(this.testelements, dropResult)
    },

    draggableMove(e) {
      // Для автопрокрутки страницы на малых экранах, когда обсласти Drag&Drop не помещаются
      const offset = 50
      const scrollStep = 20
      const clientY = e.touches[0].clientY
      const viewportHeight = document.documentElement.clientHeight;
      if (clientY > (viewportHeight - offset))
        window.scrollBy(0, scrollStep);
      if (clientY < offset)
        window.scrollBy(0, -scrollStep);
    },

    async onCardDrop(zoneIdx, dropResult) {
      // console.log('drop ' + zoneIdx, dropResult, this.testelementsDropZone)
      this.testelementsDropZone[zoneIdx].child = this.applyDrag(this.testelementsDropZone[zoneIdx].child, dropResult)

      if (dropResult.addedIndex === null) {
        this.testelementsDropZone[zoneIdx].color = 'white'
      } else if (this.testmode == 1) {
        this.testelementsDropZone[zoneIdx].color = 'blue'
        this.testelementsDropZone[zoneIdx].correct = (dropResult.payload.idtestelement === this.testelementsDropZone[zoneIdx].idtestelement)
        await this.play(this.okChord)
      } else if (dropResult.payload.idtestelement === this.testelementsDropZone[zoneIdx].idtestelement) {
        this.testelementsDropZone[zoneIdx].correct = true
        this.testelementsDropZone[zoneIdx].color = 'green'
        if (dropResult.payload.audio) {
          await this.play(dropResult.payload.audio)
        } else {
          await this.play(this.okChord)
        }
      } else {
        this.testelementsDropZone[zoneIdx].correct = false
        this.testelementsDropZone[zoneIdx].color = 'red'
        await this.play(this.errorChord)
      }

      let done = true // все ответы выбраны
      this.errorCount = 0
      this.testelementsDropZone.forEach(function (zone) {
        if (zone.correct !== true) this.errorCount++
        if (zone.correct !== true && zone.correct !== false) done = false
      }, this)
      this.complete = !this.errorCount
      this.done = done

      if (this.testmode == 0 && this.complete) {
        this.next()
      }
    },
    getCardPayload(zoneIdx) {
      return index => {
        return this.testelementsDropZone[zoneIdx].child[index]
      }
    },
    log(...params) {
      console.log(...params)
    },

    applyDrag(arr, dragResult) {
      const {removedIndex, addedIndex, payload} = dragResult
      if (removedIndex === null && addedIndex === null) return arr

      const result = [...arr]
      let itemToAdd = payload

      if (removedIndex !== null) {
        itemToAdd = result.splice(removedIndex, 1)[0]
      }

      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd)
      }

      return result
    },

  },
}
</script>

<style scoped>

@media (max-width: 1199.98px) {
  .smooth-dnd-container {
    min-height: 100px !important;
  }
}

.smooth-dnd-container {
  min-height: 250px;
  width: 100%;
  padding: 0;
  margin: 0;
  display: inline-block !important;
}

.smooth-dnd-draggable-wrapper {
  display: inline-block !important;
}

.form-ghost {
  transition: 0.18s ease;
  box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.08);
}

.form-ghost-drop {
  box-shadow: 0 0 2px 5px rgba(0, 0, 0, 0.0);
}

.drop-preview {
  background-color: rgba(150, 150, 200, 0.1);
  border: 1px dashed #abc;
  margin: 5px;
}

.cards-drop-preview {
  background-color: rgba(150, 150, 200, 0.1);
  border: 1px dashed #abc;
  margin: 5px 45px 5px 5px;
}
</style>
